<template>
  <div class="content">
    <div class="phone-container">
      <div class="phone-card">
        <form>
          <!-- 标题 -->
          <div class="phone-header">
            <h2>修改手机号</h2>
            <p>无法直接修改手机号，请联系客服</p>
          </div>

          <!-- 手机号输入 -->
          <div class="form-group">
            <label>手机号</label>
            <div class="input-group">
              <input v-model="mobile" size="12" maxlength="12" placeholder="请输入手机号" type="text" />
            </div>
          </div>

          <!-- 提示文字 -->
          <p class="phone-tip">无法修改手机号码，<a @click="$parent.openKefu">联系客服</a></p>

          <!-- 提交按钮 -->
          <button type="button" class="submit-button" @click="isOk">确认</button>
        </form>

        <!-- 弹窗 -->
        <div class="pay-dialog" style="display: none">
          <div class="pay-password">
            <div class="pay-password__header">提示<i class="pay-password__close"></i></div>
            <p class="pay-password__title"><span></span></p>
            <div><a href="javascript:void(0);" class="pay-password__button"> 联系客服 </a></div>
          </div>
        </div>

        <div class="pay-dialog unbind-pwd-dialog" style="display: none">
          <div class="pay-password">
            <div class="pay-password__header">提示<i class="pay-password__close"></i></div>
            <i class="unbind-waring"></i>
            <p class="pay-password__title"><span>为确保您的账户安全，请联系客服修改</span></p>
            <div><a href="javascript:void(0);" class="pay-password__button"> 联系客服 </a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modifyPhone',
  data() {
    return {
      mobile: null,
    };
  },
  created() {
    this.mobile = this.$store.state.userInfo.mobile;
  },
  methods: {
    isOk() {
      const url = '/api/updateuserinfo';
      const info = {};
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      info.mobile = this.mobile;
      info.birthday = userInfo.birthday;
      info.email = userInfo.email;

      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(this.mobile)) {
        this.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      this.$parent.showLoading();
      this.$apiFun.post(url, info).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
        } else {
          this.$parent.showTost(1, res.message);
          this.$parent.getUserInfos();
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 30px 15px;
  display: flex;
  justify-content: center;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;  
}

/* 卡片容器 */
.phone-container {
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
}

.phone-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  box-sizing: border-box;
  width: 100%;
}

/* 标题 */
.phone-header {
  text-align: center;
  margin-bottom: 30px;
}

.phone-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 6px;
}

.phone-header p {
  font-size: 14px;
  color: #718096;
}

/* 表单 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #4a5568;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-group input {
  width: 100%;
  padding: 12px 15px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  box-sizing: border-box;
  transition: all 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(66,153,225,0.2);
  background: #fff;
}

/* 提示文字 */
.phone-tip {
  font-size: 13px;
  color: #718096;
  margin: 10px 0 20px;
}

.phone-tip a {
  color: #4299e1;
  text-decoration: none;
  cursor: pointer;
}

.phone-tip a:hover {
  text-decoration: underline;
}

/* 提交按钮 */
.submit-button {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(66,153,225,0.2);
  box-sizing: border-box;
}

.submit-button:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(66,153,225,0.3);
}

.submit-button:active {
  transform: translateY(0);
}

/* 弹窗保持原样 */
.pay-dialog .pay-password {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  max-width: 380px;
  margin: 0 auto;
  text-align: center;
}

.pay-password__header {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 15px;
}

.pay-password__title span {
  font-size: 14px;
  color: #718096;
}

.pay-password__button {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 25px;
  background: #4a90e2;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.pay-password__button:hover {
  background: #3b82f6;
}

/* 响应式 */
@media (max-width: 480px) {
  .phone-card {
    padding: 20px;
  }

  .phone-header h2 {
    font-size: 20px;
  }

  .submit-button {
    padding: 12px 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/modifyPhone.vue